import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.p`
  color ${p => p.theme.colors.alerts[p.type]}
`;

const AlertText = ({ type = 0, children }) =>
  <Text type={type}>
    {children}
  </Text>;
AlertText.propTypes = {
  type: PropTypes.number,
  children: PropTypes.array,
};

export default AlertText;
